﻿import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListSammelstelle extends GuiListGeneric {
    constructor() {
        super("Sammelstelle");

    }
}
